import type { PromptsHeaderProps } from "../types";

import React from "react";
import { useBrand } from "@webuild-ai/react-auth";

import { PageTitle } from "@/components/UI/PageTitle";

export const PromptsHeader: React.FC<PromptsHeaderProps> = () => {
  const { brand } = useBrand();

  return (
    <PageTitle
      centered
      dataId="prompts-title"
      icon="solar:code-bold"
      img={`/brands/${brand.prefix || "webuild"}/prompt.svg`}
      subtitle="Prompt Library Description"
      title={brand.menuItems?.["Prompt Library"]?.name || "Prompt Library"}
    />
  );
};
